import React from 'react';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import Button from '../../../../components/button';
import AnimatedCheckMark from '../../../../components/sprite/components/animated-checkmark';
import GooeyProgressBar from '../../../../components/sprite/components/gooey-progress-bar';
import {isProfileUpdatePropagationPopup} from '../../../../../actions/popupActions';
import {getProfile} from '../../../../../actions/profileActions';
import './index.css';

function MyProfileUpdatePropagation () {

	const { t } = useTranslation();
	const dispatch = useDispatch();

	const closeHandler = () => {
		dispatch(isProfileUpdatePropagationPopup(false));
		dispatch(getProfile(true));
	};

	return (
		<div className="my-profile-update-propagation">
			<div className="text-center">
				<AnimatedCheckMark className="my-4"/>
				<GooeyProgressBar/>
				<h2>{t("myProfileUpdatePropagationTitle")}</h2>
				<p>{t("myProfileUpdatePropagationMessage")}</p>
				<Button onClick={closeHandler} className="mt-2 btn-primary">Ok</Button>
			</div>
		</div>
	)
}

export default MyProfileUpdatePropagation;